module.exports = __webpack_public_path__ + "static/media/icon_benefit_brain.febb9623.svg";